// extracted by mini-css-extract-plugin
export var list = "footer-links-module--list--vn7G7";
export var item = "footer-links-module--item--ENkuk";
export var icon = "footer-links-module--icon--ezXXx";